const routes = [
    {
        path: "/lms",
        component: () => import("../pages/Courses.vue"),
        meta: {
            isAuthenticated: true,
            permission: ""
        }
    },

];

export default routes;
